<template>
  <div ref="viewBox">
    <van-nav-bar title="公共服务" left-arrow @click-left="onClickLeft" />
    <div class="">
      <div class="title">
        <img
          src="@/assets/images/shehuifuwu_01.jpg"
          alt=""
          @click.prevent="getParInfo"
        />
      </div>
      <div class="con">
        <img
          src="@/assets/images/shehuifuwu_02.jpg"
          alt=""
          @click.prevent="getCitizenCart"
          @load="loadImage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import {getParInfo} from '@/api/banner'

export default {
  name: 'SheHuiFuWu',
  data() {
    return {
      showLoading: true,
    };
  },
  created() {
    let title = '公共服务';
    if (this.$getUA() === 1) {
      this.$callApp('Android', 'onJSAppSetTitle', title); //调用安卓的设置标题方法
    } else if (this.$getUA() === 2) {
      this.$callApp('iOS', 'getWebViewTitleMethod', title); //调用IOS设置标题的方法
    }
  },
  methods: {
    getParInfo() {
      var that = this;
        var PhoneNumber = Cookies.get('phone')
        var params = {
          'tel': PhoneNumber
        }
        getParInfo(params).then(res =>{
            if (res) {
            console.log(res)
            if (res.data.code == 0) {
              window.location.href = res.data.gotourl
              this.$callApp('iOS','ShowWebBackButtonMethod','')
            } else if (res.data.code == -2 || res.data.code === -1) {
              // console.log('登录超时，重新登录')
              this.$callApp('Android', 'AppLogin', localStorage.isLogin);
              this.$callApp('iOS', 'AppLoginMethod', localStorage.isLogin);
            }
          }
        })
    },
    getCitizenCart() {
      this.$router.push({ path: '/puhui/services/shehuifuwu/citizencard' });
    },
    loadImage() {
      this.showLoading = false;
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
};
</script>

<style scoped>
img {
  width: 100%;
  height: auto;
}
</style>
